/** * * Asynchronously loads the component for
ManageTicket
* */ import { lazyLoad } from "utils/loadable";
export const ManageTicket = lazyLoad(
  () => import("./index"),
  (module) => module.ManageTicket
);
